import React from "react";

import { Button } from "@replo/design-system/components/button/Button";

export function ChipButton({
  onClick,
  startEnhancer,
  children,
}: React.PropsWithChildren<{
  onClick?: () => void;
  startEnhancer?: React.ReactNode;
}>) {
  return (
    <Button
      variant="secondary"
      size="base"
      startEnhancer={startEnhancer}
      onClick={onClick}
      UNSAFE_className="font-normal rounded-md"
    >
      {children}
    </Button>
  );
}
